"use client"
import Link from "next/link";
import { usePathname } from "next/navigation";


const DownloadsNav = () => {
    const pathname = usePathname();

    return (
        <>
            <div className="tabs-container mt-40">
                <ul className="custom-tabs nav">
                    <li>
                        <Link href="/downloads/act-and-rules" className={`${pathname === "/downloads/act-and-rules" ? "active" : ""} nav-link`}>
                            Act And Rules
                        </Link>
                    </li>
                    <li>
                        <Link href="/downloads/seniority-list" className={`${pathname === "/downloads/seniority-list" ? "active" : ""} nav-link`}>
                            Seniority List
                        </Link>
                    </li>
                    <li>
                        <Link href="/downloads/forms" className={`${pathname === "/downloads/forms" ? "active" : ""} nav-link`}>
                            Forms
                        </Link>
                    </li>
                    
                </ul>
            </div>
        </>

    );
}

export default DownloadsNav
